module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div>\n    <div class="body" style="display: block">\n\n        <div class="modal-icon"><i class="fa fa-' +
((__t = (modalSettings.icon)) == null ? '' : __t) +
'"></i></div>\n\n        ';
 if (modalSettings.title) { ;
__p += '\n        <h4>' +
((__t = (modalSettings.title)) == null ? '' : __t) +
'</h4>\n        ';
 } ;
__p += '\n\n        ' +
((__t = (message)) == null ? '' : __t) +
'\n\n        ';
 if (modalSettings.ok) { ;
__p += '\n        <div data-modal-ok class="btn-ok button green">OK</div>\n        ';
 } ;
__p += '\n\n        ';
 if (modalSettings.cancel && modalSettings.confirm) { ;
__p += '\n\n        <div class="modal-button-container">\n            <div data-modal-cancel class="btn-ko button red">No</div>\n            <div data-modal-confirm class="btn-ok button green">Yes</div>\n        </div>\n\n        ';
 } ;
__p += '\n    </div>\n    <div class="preload" style="display: none">\n\n        <i class="fa fa-cog fa-spin"></i>\n\n    </div>\n</div>';

}
return __p
}